import axios from "axios";
//var url = "http://localhost:3000"
var url = "https://api.terraaqua.rs"
const API = axios.create({
  baseURL: url + "/api/v1/",
  headers: {
    authorization: {
      toString () {
        return `Bearer ${localStorage.getItem('user_jwt')}`
      }
    }
  }
})


API.interceptors.response.use((response) => {
  return response;
}, function (error) {
  // Do something with response error
  if (error.response && error.response.status === 403) {
    localStorage.removeItem("user_jwt")
    window.location.replace("/login");
  }
  return Promise.reject(error.response);
});


API.defaults.timeout = 10000;


export default API;
